const imageDomain = 'https://imgrnd.travelatacdn.ru';

export default Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        cover: null,
    },
    initialize({ id }) {
        this.set('cover', `${window.appConfig.imagesDomain || imageDomain}/photos/operator/${id}.png`); //todo imagesDomain не прописан
    },
});